import React from "react";
import Helmet from "react-helmet";
import TopicList from "app/topics/TopicList";
import { Page } from "app/topics/TopicsPage";

class Homepage extends React.Component {
  render() {
    const { intl } = this.props;
    const title = intl.formatMessage({
      id: "app.homepage.title",
      defaultMessage: "Home"
    });
    return (
      <Page>
        <Helmet title={title} />
        <TopicList intl={this.props.intl} />
      </Page>
    );
  }
}

export default Homepage;



// WEBPACK FOOTER //
// ./src/app/home/Homepage.js